import { BACKEND_BASE_URL } from '@/config.ts'
import api from '@/repositories/apiInterceptor.ts'

export const getAppVersion = (): Promise<string> =>
  api.get(`${BACKEND_BASE_URL}/api/version`).then((response) => response.data)
